import { Transaction } from '@/features/bankid/components/transaction';

export function BankIdPage() {
  return (
    <div className="mx-auto space-y-4 flex flex-col items-center">
      <Transaction />
    </div>
  );
}
